import { useEffect, useState } from "react";

export function RadioGroupComponent({
  items,
  id,
  defaultValue,
  onChange,
}: {
  id?: string;
  onChange: (value: string) => void;
  items: IRadioGroupItem[];
  defaultValue: string;
}) {
  const [selectedValue, setSelectedValue] = useState<string>();

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);
  return (
    <div
      className="flex flex-row gap-10 border rounded-md border-gray-600 w-fit px-4 py-1"
      id={id}
    >
      {items.map((i, idx) => (
        <div
          className="flex gap-1"
          key={idx}
          onClick={() => {
            setSelectedValue(i.value);
            onChange(i.value);
          }}
        >
          <input
            type="radio"
            className="cursor-pointer"
            checked={i.value === selectedValue}
            value={i.value}
          />
          <label className="cursor-pointer">{i.label}</label>
        </div>
      ))}
    </div>
  );
}

interface IRadioGroupItem {
  label: string;
  value: string;
}
